import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import logo from "../../../assets/images/logo.png";
import styles from "./CustomerLogin.module.css";

import { LuEye, LuEyeOff } from "react-icons/lu";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Dropdown,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../components";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { validateEmail } from "../../../utills/Validators";

function CustomerLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [roleError, setRoleError] = useState("");
  const [canSubmit, setCanSubmit] = useState(false);
  const location = useLocation();

  const [role, setRole] = useState({
    value: "Dealership",
    id: 1,
  });
  const [passwordVisible, setPasswordVisible] = useState(false);

  const onPressLogin = (e) => {
    e.preventDefault();
    let userData = {
      email: email,
      password: password,
      role: role.value,
      redirect_url: location?.pathname,
    };
    if (!email) {
      dispatch(
        showAlert({ type: "Error", message: "Email Field is Required!" }),
      );
    } else if (!password) {
      dispatch(
        showAlert({ message: "Password Field is Required!", type: "Error" }),
      );
    } else if (!validateEmail(email)) {
      dispatch(
        showAlert({
          message:
            "Please enter a valid email address in the correct format (e.g: example@example.com)",
        }),
      );
      return;
    } else if (!role) {
      dispatch(
        showAlert({ message: "Please Select User Role!", type: "Error" }),
      );
      return;
    } else {
      dispatch(AuthMiddleware.login(userData)).then((data) => {
        // console.log("id..........", data);
        navigate("/company-portal");

        if (data?.is_2fa_enabled == 1) {
          navigate("/verifyCode", {
            state: { screen: "login", role: role?.value, id: data?.id },
          });
        }
      });
    }
  };

  useEffect(() => {
    if (emailError || passwordError || !email || !password || !role?.value) {
      setCanSubmit(false);
    } else {
      setCanSubmit(true);
    }
  }, [email, password, role, emailError, passwordError, roleError]);

  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <img src={logo} className={styles.logoImg} />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.subRightCont}>
          <div className={styles.rightWidthCont}>
            <form onSubmit={(e) => onPressLogin(e)}>
              <div className={styles.inputDiv}>
                <InputField
                  className={styles.input}
                  label="Email Address"
                  placeholder="chris@email.com"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);

                    // live validation
                    if (!e.target.value) {
                      setEmailError("Email is required");
                    } else if (!validateEmail(e.target.value)) {
                      setEmailError("Enter a valid email address");
                    } else {
                      setEmailError("");
                    }
                  }}
                  error={emailError}
                />

                <InputField
                  className={styles.input}
                  label="Password"
                  placeholder="●●●●●●●●●●"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);

                    // live validation
                    if (!e.target.value) {
                      setPasswordError("Password is required");
                    } else {
                      setPasswordError("");
                    }
                  }}
                  rightIcon={
                    passwordVisible ? (
                      <LuEye size={20} color={"var(--input-icon)"} />
                    ) : (
                      <LuEyeOff size={20} color={"var(--input-icon)"} />
                    )
                  }
                  onRightIconPress={() => setPasswordVisible(!passwordVisible)}
                  type={passwordVisible ? "text" : "password"}
                  error={passwordError}
                />

                {/* <Dropdown
                  className={styles.input}
                  label={"Role"}
                  value={role}
                  labelStyle={{ color: "#838383", fontSize: 18 }}
                  style={{ color: "black" }}
                  options={[
                    { value: "Dealership", id: 1 },
                    { value: "Customer", id: 2 },
                    { value: "Company", id: 3 },
                  ]}
                  onChange={(value) => {
                    setRole(value);
                    if (!value?.value) {
                      setRoleError("Role is required");
                    } else {
                      setRoleError("");
                    }
                  }}
                  onBlur={() => {
                    if (!role?.value) {
                      setRoleError("Role is required");
                    } else {
                      setRoleError("");
                    }
                  }}
                  error={roleError}
                /> */}
              </div>
              <div className={styles.btn}>
                <SubmitButton
                  title={"Login"}
                  type="submit"
                  disabled={!canSubmit}
                  style={{
                    cursor: canSubmit ? "pointer" : "default",
                    background: !canSubmit && "#dadada",
                  }}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerLogin;
